import * as React from 'react';
import locales from '../locales';
import {ColumnFilterItem} from "antd/lib/table";
import {EventAlertState} from "../api/dtos/dtos";
import {AppColors} from "../statistics/utils/colors";

const stateToColorClass = {
  [EventAlertState.NEW]: AppColors.GREEN,
  [EventAlertState.TRIGGERED]: AppColors.RED,
  [EventAlertState.HANDLED]: AppColors.MEDIUM_GRAY,
};

export const eventAlertStateToText = {
  [EventAlertState.NEW]: locales.event_alert_state_new,
  [EventAlertState.TRIGGERED]: locales.event_alert_state_triggered,
  [EventAlertState.HANDLED]: locales.event_alert_state_handled,
};

export function renderEventAlertStateCondensed(state: string | undefined): React.ReactNode {
  const txt = state ? eventAlertStateToText[state] : locales.event_alert_state_new;
  return (
    <div style={{textAlign: 'center'}} title={txt}>
      {renderStateSpan(state)}
    </div>
  );
}

function renderStateSpan(state: string | undefined): React.ReactNode {
  const colorCls = state ? stateToColorClass[state] : 'grey';
  return <span className={'state-dot ' + colorCls}/>;
}

export function getEventAlertStateFilters(): ColumnFilterItem[] {
  return [EventAlertState.NEW, EventAlertState.TRIGGERED, EventAlertState.HANDLED]
    .map(state => ({text: eventAlertStateToText[state], value: state}));
}


// WEBPACK FOOTER //
// ./src/event-alerts/eventAlertState.tsx